module.exports = __webpack_public_path__ + "img/instagramIcon.a299367e.png";